module.exports = __webpack_public_path__ + "static/Kollektif-BoldItalic-6763df240291636923f89e208ef12b5e.ttf";